/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterY = createReactComponent("outline", "letter-y", "IconLetterY", [["path", { "d": "M7 4l5 9l5 -9", "key": "svg-0" }], ["path", { "d": "M12 13l0 7", "key": "svg-1" }]]);

export { IconLetterY as default };
//# sourceMappingURL=IconLetterY.mjs.map
